import React from 'react';
import PropTypes from 'prop-types';
import { withFormsy } from 'formsy-react';
import helpers from '../../resources/helpers';

import BasicInput from '../form-elements/BasicInput';
import HiddenInput from '../form-elements/HiddenInput';

class EmailInput extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			touched: false,
			hasFocus: false,
			hasValue: (props.value || '') !== '',
			value: props.value,
			isValid: true,
			strikeironValidated: false,
			validatedEmail: '',
		};

		this.handleLabelClick = this.handleLabelClick.bind(this);
		this.handleFocus = this.handleFocus.bind(this);
		this.handleBlur = this.handleBlur.bind(this);
		this.handleValueChange = this.handleValueChange.bind(this);
		this.validateEmail = this.validateEmail.bind(this);
		this.showError = this.showError.bind(this);
	}

	componentWillReceiveProps(props) {
		const value = props.value;
		this.setState(
			{
				hasValue: (value || '') !== '',
				value,
			},
			() => {
				if (value) {
					this.validateEmail(value);
				}
			}
		);
	}

	// Event Handlers
	handleLabelClick() {
		this.inputRef.handleFocus();
	}

	handleFocus() {
		if (this.props.onFocus) {
			this.props.onFocus();
		}
		this.setState({
			touched: true,
			hasFocus: true,
		});
	}

	async handleBlur() {
		const isValid = await this.validateEmail(this.state.value);
		if (this.props.onBlur) {
			this.props.onBlur(this.state.value);
		}
		this.setState({
			hasFocus: false,
			isValid,
		});
	}

	handleValueChange(value) {
		this.props.setValue(value);

		if (this.props.onChange) {
			this.props.onChange(value, this.state.touched);
		}

		this.setState({
			value,
			hasValue: value !== '',
		});
	}

	validateEmail(value) {
		if (value !== this.state.validatedEmail) {
			const re =
				/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
			const passesRegEx = re.test(String(value).toLowerCase());
			this.setState(
				{
					validatedEmail: passesRegEx ? value : '',
					strikeironValidated: false,
				},
				async () => {
					if (passesRegEx) {
						const strikeironValidated = await helpers.validateEmailWithStrikeiron(value);
						this.setState({
							strikeironValidated,
						});
					}
				}
			);
			return passesRegEx;
		}
		return true;
	}

	showError() {
		return this.state.touched && !this.state.hasFocus && !this.state.isValid;
	}

	render() {
		const { showError, errorMessage } = helpers.shouldComponentShowError({
			showError: this.props.showError,
			formHasHadAnInValidSubmit: this.props.formHasHadAnInValidSubmit,
			required: this.props.required,
			getErrorMessage: () => this.props.errorMessage,
			errorMessage: this.props.errorMessage,
			currentValue: this.state.value,
		});

		return (
			<div>
				<BasicInput
					innerRef={(c) => (this.inputRef = c)}
					label={this.props.label || 'Email'}
					name={this.props.name}
					tooltip={this.props.tooltip}
					optionalLabel={this.props.optionalLabel}
					type="text"
					value={this.state.value}
					onFocus={this.handleFocus}
					onBlur={this.handleBlur}
					onChange={this.handleValueChange}
					required={this.props.required}
					showError={showError}
					errorMessage={errorMessage}
				/>
				{!this.state.isValid && (
					// Prevents form from treating field as valid
					<HiddenInput name="_____hidden_email_validation" required={this.props.required} />
				)}
				{this.state.strikeironValidated && <HiddenInput name="email_validated" value={true} />}
			</div>
		);
	}
}

EmailInput.propTypes = {
	required: PropTypes.bool,
	hidden: PropTypes.bool,
	hideLabel: PropTypes.bool,
	lockLabel: PropTypes.bool,
	label: PropTypes.string,
	tooltip: PropTypes.string,
	optionalLabel: PropTypes.string,
	className: PropTypes.string,
	showError: PropTypes.any,
	errorMessage: PropTypes.string,
	getErrorMessage: PropTypes.func,
	name: PropTypes.string.isRequired,
	value: PropTypes.any,
	onChange: PropTypes.func,
	onFocus: PropTypes.func,
	onBlur: PropTypes.func,
	formHasHadAnInValidSubmit: PropTypes.bool,
};

export default withFormsy(EmailInput);
